// THIS FILE IS ONLY FOR VARIABLES
// DO NOT PUT ANY LOGIC IN HERE AS IT BLOCKS THE PAGE

window.kbconfig = {
  API_URL: 'https://apex-api.kitbash3d.com',
  CARGO_URL: 'https://cargo-app.kitbash3d.com',
}
